import React from 'react';
import MetricTrackingPage from './MetricTrackingPage';

export default function GestionWeights() {
  return <MetricTrackingPage type="weight" title="Peso corporal" description="Registra tu peso de forma sencilla y consulta la evolución de tus últimas mediciones." field="weight" unit="kg" inputLabel="Peso" />;
}
